import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '无删减原版内容',
    desc: '坚持提供韩国漫画无删减版本，保留原作者所有画面和情节，让读者体验最完整的漫画故事。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式流畅阅读',
    desc: '专为移动端和桌面端优化的下拉式阅读体验，无需翻页，滑动即可连续阅读韩国漫画。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    desc: '所有韩国漫画资源完全免费，没有任何隐藏收费，让每一位漫画爱好者都能自由畅享阅读。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '紧跟韩国连载进度，每日更新最新章节，让读者第一时间看到最新的漫画内容。',
  },
  {
    icon: 'ri-heart-2-line',
    title: '可爱风格精选',
    desc: '专注可爱风格的韩国漫画内容，精心挑选恋爱、治愈、日常等温暖题材作品。',
  },
  {
    icon: 'ri-global-line',
    title: '随时随地阅读',
    desc: '支持手机、平板和电脑等多种设备访问，随时随地打开浏览器就能享受漫画阅读乐趣。',
  },
];

const testimonials = [
  {
    name: '小桃子',
    role: '忠实读者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20in%20pastel%20pink%20style%2C%20simple%20flat%20illustration%2C%20round%20profile%20picture&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '桃桃漫画网的漫画画质超好，下拉式阅读真的很方便！每天都会来看看有没有更新，已经成了我的日常习惯。',
    rating: 5,
  },
  {
    name: '甜橙子',
    role: '韩漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20orange%20hair%2C%20simple%20flat%20illustration%2C%20round%20profile%20picture%2C%20kawaii%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '终于找到一个无删减的韩漫网站了！之前在其他平台看的都是删减版，这里的完整版体验完全不一样。',
    rating: 5,
  },
  {
    name: '草莓酱',
    role: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20red%20hair%2C%20simple%20flat%20illustration%2C%20round%20profile%20picture%2C%20kawaii%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '可爱风格的韩国漫画资源很丰富，分类也很清晰！推荐给了好多朋友，大家都说好用。',
    rating: 5,
  },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          {/* Breadcrumb */}
          <div className="py-4">
            <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />
          </div>

          {/* Hero */}
          <section className="py-10 md:py-14 text-center">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-4">
              关于桃桃漫画网
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              桃桃漫画网是一个专注于韩国漫画无删减下拉式在线阅读的平台，
              致力于为漫画爱好者提供优质的韩国漫画阅读体验，以可爱风格内容为核心特色。
            </p>
          </section>

          {/* Brand Story */}
          <section className="py-10 md:py-14">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">品牌故事</h2>
                <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    桃桃漫画网诞生于对韩国漫画的热爱。我们的创始团队是一群资深的韩漫爱好者，
                    在多年的漫画阅读经历中，发现了市场上韩国漫画资源分散、质量参差不齐、
                    很多平台存在内容删减和阅读体验不佳的问题。
                  </p>
                  <p>
                    于是我们决定打造一个专注于韩国漫画的在线阅读平台，以<strong>无删减、高质量、免费</strong>
                    为核心价值，为所有韩漫爱好者提供最好的阅读体验。
                    &ldquo;桃桃&rdquo;这个可爱的名字代表了我们对漫画的纯真爱意，
                    也象征着我们专注于可爱风格漫画的内容定位。
                  </p>
                  <p>
                    从上线以来，桃桃漫画网已经积累了超过<strong>1000部</strong>精选韩国漫画资源，
                    覆盖恋爱、奇幻、日常、治愈等多种题材，服务了<strong>50万+</strong>的忠实读者用户。
                    我们每天都在努力为大家带来更多优质内容。
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0 w-full lg:w-[400px]">
                <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20and%20warm%20illustration%20of%20a%20cute%20reading%20corner%20with%20stacked%20comic%20books%2C%20soft%20peach%20colored%20pillows%2C%20a%20warm%20lamp%2C%20whimsical%20and%20inviting%20atmosphere%2C%20soft%20pastel%20colors%2C%20anime-inspired%20art%20style&width=800&height=600&seq=about-brand-taotao&orientation=landscape"
                    alt="桃桃漫画网 - 品牌故事插画"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Features */}
          <section className="py-10 md:py-14">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950">平台特色</h2>
              <p className="text-sm text-foreground-500 mt-1">为什么选择桃桃漫画网？</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((feat, idx) => (
                <div
                  key={idx}
                  className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${feat.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-800 mb-1">{feat.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Testimonials */}
          <section className="py-10 md:py-14">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950">用户口碑</h2>
              <p className="text-sm text-foreground-500 mt-1">听听读者们怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t, idx) => (
                <div
                  key={idx}
                  className="p-6 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="py-10 md:py-14 pb-20">
            <div className="max-w-[700px] mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950">联系我们</h2>
                <p className="text-sm text-foreground-500 mt-1">有任何问题或建议？欢迎联系我们</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
                <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-800 mb-1">电子邮箱</h4>
                  <p className="text-xs text-foreground-500">contact@taotao-comic.com</p>
                </div>
                <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-customer-service-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-800 mb-1">在线客服</h4>
                  <p className="text-xs text-foreground-500">工作日 9:00 - 18:00</p>
                </div>
                <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-800 mb-1">公司地址</h4>
                  <p className="text-xs text-foreground-500">中国·北京市朝阳区</p>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                <h3 className="text-base font-heading text-foreground-900 mb-5">发送消息</h3>
                <form
                  data-readdy-form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const formEl = e.currentTarget;
                    const formData = new FormData(formEl);
                    const hp = (formData.get('phone_alt') as string || '').trim();
                    if (hp) {
                      const alertEl = document.getElementById('contact-msg');
                      if (alertEl) {
                        alertEl.textContent = '消息已发送，我们会尽快回复！';
                        alertEl.className = 'mt-4 text-sm text-accent-600';
                      }
                      formEl.reset();
                      return;
                    }
                    try {
                      const res = await fetch('https://readdy.ai/api/form/d9peq8hn2trhb35gve50', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams({
                          name: formData.get('name') as string,
                          email: formData.get('email') as string,
                          message: formData.get('message') as string,
                        }).toString(),
                      });
                      const text = await res.text();
                      let parsed: any = {};
                      try { parsed = JSON.parse(text); } catch { /* ignore */ }
                      const alertEl = document.getElementById('contact-msg');
                      if (res.ok && parsed?.code === 'OK') {
                        if (alertEl) {
                          alertEl.textContent = '消息已发送，我们会尽快回复！';
                          alertEl.className = 'mt-4 text-sm text-accent-600';
                        }
                        formEl.reset();
                      } else {
                        const msg = parsed?.meta?.message || parsed?.message || '发送失败，请重试';
                        if (alertEl) {
                          alertEl.textContent = msg;
                          alertEl.className = 'mt-4 text-sm text-red-500';
                        }
                      }
                    } catch {
                      const alertEl = document.getElementById('contact-msg');
                      if (alertEl) {
                        alertEl.textContent = '网络错误，请检查连接后重试';
                        alertEl.className = 'mt-4 text-sm text-red-500';
                      }
                    }
                  }}
                >
                  <div className="hidden" aria-hidden="true">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-xs text-foreground-600 mb-1.5">姓名</label>
                      <input
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 focus:outline-none focus:border-primary-300 text-foreground-800 placeholder:text-foreground-400"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-foreground-600 mb-1.5">邮箱</label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 focus:outline-none focus:border-primary-300 text-foreground-800 placeholder:text-foreground-400"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="block text-xs text-foreground-600 mb-1.5">消息内容</label>
                    <textarea
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 focus:outline-none focus:border-primary-300 text-foreground-800 placeholder:text-foreground-400 resize-none"
                      placeholder="请输入您想说的话（最多500字）"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="px-8 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <p id="contact-msg" className="mt-4 text-sm"></p>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      {/* About Page Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于桃桃漫画网 - 韩国漫画无删减下拉式在线阅读平台',
            description: '桃桃漫画网专注于韩国漫画无删减下拉式在线阅读，提供可爱风格免费韩漫资源，每日更新最新章节。',
            url: 'https://taotao-comic.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '桃桃漫画网',
              url: 'https://taotao-comic.com/',
            },
            inLanguage: 'zh-CN',
          }),
        }}
      />
    </>
  );
}